import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { NightlyButton, NightlyButtonProps } from './NightlyButton'

export const NightlyButtonRegistration = createRegisterableComponent(
    'nightly-button',
    (props: NightlyButtonProps) => <NightlyButton {...props} />,
)
